import { render, staticRenderFns } from "./FrsZonesAverage.vue?vue&type=template&id=04f57cce&scoped=true&lang=html&"
import script from "./FrsZonesAverage.vue?vue&type=script&lang=js&"
export * from "./FrsZonesAverage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f57cce",
  null
  
)

export default component.exports